<template>
<div class="wc2026-inner">
  <!-- 顶部 Banner 切图区域 -->
  <div class="page-banner">
    <!-- 预留 Banner 图片切图，尺寸 750×340（设计稿尺寸） -->
    <img class="banner-img-slot" :src="banner" />


  </div>
</div>
</template>

<script setup>
import { computed } from 'vue'

import { useI18n } from 'vue-i18n'
import bannerVi from '@/assets/imgs/act/wc2026/banner/vi.png'
import bannerTh from '@/assets/imgs/act/wc2026/banner/th.png'
import bannerId from '@/assets/imgs/act/wc2026/banner/id.png'
import bannerZh from '@/assets/imgs/act/wc2026/banner/zh.png'
import bannerEn from '@/assets/imgs/act/wc2026/banner/en.png'
const locale = useI18n().locale
const banner = computed(() => {

  switch (locale.value) {
    case 'vi':
      return bannerVi
    case 'th':
      return bannerTh
    case 'id':
      return bannerId
    case 'tw':
      return bannerZh
    case 'en':
      return bannerEn
    case 'hk':
      return bannerZh
    default:
      return bannerEn
  }
})



</script>

<style lang="less" scoped>
.banner-img-slot {
  width: 100%;
  height: auto;
  object-fit: cover;
}
</style>